import { Modal } from 'antd';
import ProjectForm from './forms/projectForm';
import { useAppContext } from '../../providers/AppContext';

const ProjectModal = () => {
  const { configStates, updateConfigStates } = useAppContext();

  const handleCancel = () => {
    updateConfigStates({ showProject: false });
  };

  return (
    <>
      <Modal
        open={configStates.showProject}
        onCancel={handleCancel}
        footer={null}
        title="New Project"
        width={750}
      >
        <ProjectForm handleCancel={handleCancel} />
      </Modal>
    </>
  );
};

export default ProjectModal;
